import './style.scss';
import React, {PropTypes} from 'react';
import _ from 'lodash';

import {serverToDisplayDate} from 'app/lib/format';

import TimeSlot from './TimeSlot';


const Day = ({day, data, begin, end, onChange, onDateChange, ...other}) => {

    const displayDay = serverToDisplayDate(day);

    const selectHandler = (timeSlot) => {
        onChange(timeSlot);
        onDateChange(displayDay);
    };

    return (
        <div className="timeslotpicker__day">
            <div className="date">{displayDay}</div>
            {_.map(data, (timeSlot, index) => (
                <TimeSlot timeSlot={timeSlot} key={index} onSelect={selectHandler} day={day} {...other} />
            ))}
        </div>
    );
};

Day.propTypes = {
    day: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    begin: PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
    end: PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default Day;
